<template>
    <checkout-step step-num="1" :step="step" stepName="Delivery Date and Recipient Details" @continue="validate" @edit="$emit('edit')">
        <div slot="active">
            <b-field :message="errors.first('delivery_date')" label="Requested Delivery Date">
                <b-datepicker placeholder="Delivery Date" :min-date="minDate" :max-date="maxDate" v-model="data.delivery_date" name="delivery_date" v-validate="{ required: true }"></b-datepicker>
            </b-field>

            <b-field grouped>
                <b-field :message="errors.first('recipient_fname')" label="Recipient Name" expanded>
                    <b-input type="text" name="recipient_fname" placeholder="First Name" expanded v-model.trim="data.recipient_fname" v-validate="{required: true, min: 1, max: 255}"></b-input>
                </b-field>
                <b-field :message="errors.first('recipient_lname')" expanded label=".">
                    <b-input type="text" name="recipient_lname" placeholder="Last Name" expanded v-model.trim="data.recipient_lname" v-validate="{required: true, min: 1, max: 255}"></b-input>
                </b-field>
            </b-field>
            
            
            <b-field :message="errors.first('address')" label="Address">
                <b-input type="text" name="address" placeholder="123 Main St Apt 110" v-model.trim="data.address" v-validate="{required: true, min: 5, max: 255}"></b-input>
            </b-field>
            <b-field :message="errors.first('city')" label="City">
                <b-input type="text" name="city" placeholder="Winnipeg" v-model.trim="data.city" v-validate="{required: true, min: 2, max: 255}"></b-input>
            </b-field>
            <b-field grouped>
                <b-field expanded :message="errors.first('province')" label="Province">
                    <b-select v-model="data.province" expanded name="province" v-validate="{required: true}">
                        <!-- <option :value="null">Select Province</option>
                        <option value="ON">Ontario</option>
                        <option value="QC">Quebec</option>
                        <option value="NS">Nova Scotia</option>
                        <option value="NB">New Brunswick</option> -->
                        <option value="MB">Manitoba</option>
                        <!-- <option value="BC">British Columbia</option>
                        <option value="PE">Prince Edward Island</option>
                        <option value="SK">Saskatchewan</option>
                        <option value="AB">Alberta</option>
                        <option value="NL">Newfoundland and Labrador</option>
                        <option value="NT">Northwest Territories</option>
                        <option value="YT">Yukon</option>
                        <option value="NU">Nunavut</option> -->
                    </b-select>

                </b-field>
                <b-field :message="errors.first('postal_code')" label="Postal Code">
                    <b-input type="text" placeholder="R2J 0C7" name="postal_code" v-model.trim="data.postal_code" v-validate="{required: true, postalCode: true}"></b-input>
                </b-field>            
            </b-field>
                
            <b-field :message="errors.first('recipient_cell')" label="Recipient cell number">
                <b-input type="text" name="recipient_cell" placeholder="(204) 123 - 4567" v-model="data.recipient_cell" v-validate="{required: true, phone: true}"></b-input>
            </b-field>
            <b-field :message="errors.first('recipient_phone')" label="Recipient phone number">
                <b-input type="text" name="recipient_phone" placeholder="(204) 123 - 4567" v-model="data.recipient_phone" v-validate="{phone: true}"></b-input>
            </b-field>
            <b-field :message="errors.first('recipient_email')" label="Recipient email">
                <b-input type="email" placeholder="emailaddress@mail.com" v-model.trim="data.recipient_email" name="recipient_email" v-validate="{email: true}"></b-input>
            </b-field>
                        
        </div>
        <div slot="finished">
            <p>{{ data.delivery_date | moment("dddd, MMMM Do YYYY") }}</p>
            <p>{{ data.recipient_fname }} {{ data.recipient_lname }}</p>
            
            <p v-if="data.address != '' || data.city != '' || data.postal_code != '' || data.province != null">{{ data.address }}, {{ data.city }}, {{data.province}}, {{ data.postal_code }}</p>
            
            <p>{{ data.recipient_cell }}</p>
            <p>{{ data.recipient_phone }}</p>
            <p>{{ data.recipient_email }}</p>

        </div>
    </checkout-step>
</template>

<script>
import CheckoutStep from '../CheckoutStep';
import BDatepicker from 'buefy/src/components/datepicker/Datepicker';
import BField from 'buefy/src/components/field/Field';
import BInput from 'buefy/src/components/input/Input';
import { parse, asYouType } from 'libphonenumber-js';

export default {
  components: {
    BInput,
    BField,
    BDatepicker,
    CheckoutStep,
  },

  data() {
    const today = new Date();

    return {
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1),
//      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14),
      maxDate: new Date(today.getFullYear(), today.getMonth() + 2, today.getDate()),
      date: new Date(),
    };
  },

  name: 'checkout-step1',

  props: ['data', 'step'],

  methods: {
    validate() {
      this.$validator.validateAll().then((valid) => {
        if (valid) this.$emit('valid');
      });
    },
  },

  watch: {
    'data.recipient_phone'() {
      this.data.recipient_phone = new asYouType('CA').input(this.data.recipient_phone);
    },
    'data.recipient_cell'() {
      this.data.recipient_cell = new asYouType('CA').input(this.data.recipient_cell);
    },
  },

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/checkout-steps/CheckoutStep1.vue